import React from 'react';

// Configs
import { BACKGROUND_COLOR_NOT_SELECTED, BACKGROUND_COLOR_SELECTED } from '../../configs/tools.configs';

const ToolChartIcon = ({ selected = false, title = 'Tool Chart Icon' }: { selected: boolean; title?: string }) => {
  const backgroundColor = selected ? BACKGROUND_COLOR_SELECTED : BACKGROUND_COLOR_NOT_SELECTED;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
      className={'tool-icon'}
      role='img'
      aria-label={title}
    >
      <title>{title}</title>
      <path fill={backgroundColor} d='M0 0h40v40H0z' />
      <path
        fill='#fff'
        d='M12.865 30.791H4v8.77h8.865v-8.77ZM24.076 12h-8.867v27.561h8.867V12ZM35.284 22.021h-8.865V39.56h8.865V22.021Z'
      />
    </svg>
  );
};

export default ToolChartIcon;
